export default __webpack_public_path__ + "static/media/chat3.5faf09a7.png";